import { AsyncSelect } from "components/AsyncInput/AsyncSelect";
import { Loader } from "components/Loader/Loader";
import {
  showErrorToast,
  showSuccessToast,
} from "components/CustomAlerts/CustomToast";
import { Input } from "components/Input/Input";
import { InputFile } from "components/InputFIle/InputFile";
import { Select } from "components/Select/Select";
import { useFormik } from "formik";
import { DiseñoCurricularI } from "interfaces/DiseñoCurricular";
import { OrganismoI } from "interfaces/Organismo";
import { NormativaI } from "interfaces/Normativa";
import React, { useEffect, useState } from "react";
import { Button, Col, Modal, Row, Spinner } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { createNormativasSchema } from "schemas/normativas/createNormativasSchema";
import { OrganismosABM } from "screens/Notificaciones/components/OrganismosABM/OrganismosABM";
import { getDiseñosCurriculares } from "services/diseñoCurricular";
import { getAllOrganismos } from "services/organismos";
import {
  getDocumentacionFile,
  getNormativas,
  getNormativasJurisdiccionales,
  getUrlPrefirmada,
  postNormativa,
  postNormativaNoAnexo,
  postNormativaV2,
  putNormativa,
  putNormativaV2,
} from "services/normativas";
import { uploadFileToPresignedUrl } from "services/request/s3PutFile";
import {
  createNormativaBatch,
  editNormativaBatch,
  BatchUploadError,
} from "services/batchUpload";
import {
  fetchAlcances,
  fetchTiposEfecto,
  fetchTiposResoluciones,
} from "store/slices/appSlice";
import { AppDispatch, RootState } from "store/store";
import { formatDate } from "utils/formatUtils";
import { InputMultiFile } from "components/InputFIle/InputMultiFile";
import {
  getValidezNacional,
  getValidezNacionalExpedienteInterno,
} from "services/validezNacional";
import { ValidezNacionalI } from "interfaces/ValidezNacionalI";
import { Alcances } from "enums/Alcances";
import { DocumentacionAdjuntaI } from "dtos/documentacionAdjunta";
import { EntityID } from "api/types/EntityID";

interface Props {
  actionType: "create" | "edit" | undefined;
  onClose?: any;
  elemento?: NormativaI;
  onSuccess?: (normativa: NormativaI) => void;
  showModal: boolean;
}

type FakeFile = File & {
  fakeId: EntityID;
  isVirtual: boolean;
  nombre_real?: string;
}

interface initialValues {
  id?: string | number;
  nombre: string;
  descripcion: string;
  tipo_normativa_id: string | number;
  tipo_efecto_id: string | number;
  alcance_id: string | number;
  organismo_id: string | number;
  fecha_publicacion: Date | string;
  documentacion_adjunta: FakeFile[];
  anexos: FakeFile[];
  aplicaValidezNacional: boolean;
  normativas_id: NormativaI[];
  validaciones_nacionales_id: ValidezNacionalI[];
}

interface defaultOptionsSelected {
  default_selected_organismo: OrganismoI | null;
}

export interface requestUrlPrefirmada {
  nombre: string;
  mimeType: string;
  size: number;
  type: string;
}

type NormativaAdjuntos = Partial<Record<"documentacion_adjunta"|"anexos", File[]>>;

export const NormativasABM = ({
  showModal,
  actionType,
  onClose,
  elemento,
  onSuccess,
}: Props) => {
  const isEditMode = actionType == "edit";
  const dispatch: AppDispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(false);
  const [isLoadingFiles, setIsLoadingFiles] = useState(false);
  const [wasOriginalFileDeleted, setWasOriginalFileDeleted] = useState(false);
  const initialValues: initialValues = {
    nombre: "",
    descripcion: "",
    tipo_normativa_id: "",
    organismo_id: "",
    alcance_id: Alcances.Jurisdiccional,
    tipo_efecto_id: "1",
    fecha_publicacion: "",
    documentacion_adjunta: [],
    anexos: [],
    aplicaValidezNacional: false,
    normativas_id: [],
    validaciones_nacionales_id: [],
  };

  const [defaultOptionsSelected, setDefaultOptionsSelected] =
    useState<defaultOptionsSelected>({
      default_selected_organismo: null,
    });

  const [modalsActionType, setModalsActionType] = useState<
    "create" | "edit" | undefined
  >();
  const [showModalABM, setShowModalABM] = useState({
    organismos: false,
  });

  const renderInitialValues = async () => {
    let currentValues: initialValues;
    
    if (isEditMode && elemento)
    {
      // Seteamos los valores básicos, subimos el codigo para que tenga prioridad
      currentValues = {
        id: elemento?.id ?? "",
        nombre: elemento?.nombre ?? "",
        descripcion: elemento?.descripcion ?? "",
        tipo_normativa_id: elemento?.tipoNormativa.id ?? "",
        tipo_efecto_id: elemento?.tipoEfecto.id ?? "",
        organismo_id: elemento?.organismo.id ?? "",
        alcance_id: elemento?.alcance.id ?? "",
        fecha_publicacion: elemento?.fechaPublicacion
          ? formatDate.formDate(elemento.fechaPublicacion)
          : "",
        documentacion_adjunta: [],
        anexos: [],
        aplicaValidezNacional: elemento?.aplicaValidezNacional ?? false,
        normativas_id: elemento?.normativasArray ?? [],
        validaciones_nacionales_id: elemento?.validacionesNacionalesArray ?? [],
      };
      setDefaultOptionsSelected({
        default_selected_organismo: {
          id: elemento.organismo.id,
          nombre: elemento.organismo.nombre,
          abreviatura: elemento.organismo.abreviatura,
          descripcion: elemento.organismo.descripcion,
        },
      });
      setValues(currentValues);

      
      setIsLoadingFiles(true);
      try {
        const adjuntos: FakeFile[] = [];
        const anexos: FakeFile[] = [];

        // Obtener adjuntos
        if(elemento.documentacionAdjunta)
        {
          const adjunto = await getDocumentacionFile({
            id: elemento.documentacionAdjunta.id,
            fileName: elemento.documentacionAdjunta.nombre,
          }) as FakeFile;

          if(adjunto)
          {
            adjunto.fakeId = elemento.documentacionAdjunta.id;
            adjunto.isVirtual = true;
            adjunto.nombre_real = elemento.documentacionAdjunta.nombre_real || elemento.documentacionAdjunta.nombre;

            adjuntos.push(adjunto);
          }
        }

        // Obtener anexos
        for (const anexo of elemento.anexo) {
          if (anexo.anexo) {
            const anexoIndividual = await getDocumentacionFile({
              id: anexo.id,
              fileName: anexo.nombre,
            }) as FakeFile;

            anexoIndividual.fakeId = anexo.id;
            anexoIndividual.isVirtual = true;
            anexoIndividual.nombre_real = anexo.nombre_real || anexo.nombre;

            anexos.push(anexoIndividual);
          }
        }

        setValues((prev) => ({ ...prev, documentacion_adjunta: adjuntos, anexos }));
      } finally {
        setIsLoadingFiles(false);
      }
    } else {
      currentValues = initialValues;
      setDefaultOptionsSelected({
        default_selected_organismo: null,
      });
      setValues(currentValues);
    }
  };

  const handleSubmitCreateUrlPrefirmada = async (params: initialValues) => {
    try {
      setIsLoading(true);
      const newParams = { ...params };

      if (newParams.fecha_publicacion) {
        newParams.fecha_publicacion = new Date(
          `${newParams.fecha_publicacion}T00:00:00`,
        ).toISOString();
      }

      // Array ordenado que vincula cada File con su tipo.
      // El ORDEN es crítico: debe coincidir exactamente con el array
      // que mandamos al backend, para poder hacer el match por índice
      // con las URLs que devuelve.
      const archivosParaSubir: { file: FakeFile; tipo: 'documentacion_adjunta' | 'anexo' }[] = [
        ...params.documentacion_adjunta.map(f => ({ file: f, tipo: 'documentacion_adjunta' as const })),
        ...params.anexos.map(f => ({ file: f, tipo: 'anexo' as const })),
      ];
      // TODO: Log de desarrollo, elimninar luego de validar en DEV
      console.log('archivosParaSubir',archivosParaSubir);
      
      // ── PASO 1: Obtener URLs prefirmadas ────────────────────────────
      // Mandamos los metadatos (sin el binario) al backend.
      const urlsPrefirmadas = await getUrlPrefirmada({
        documentos: archivosParaSubir.map(a => ({
          nombre: a.file.name,
          mimetype: a.file.type,
          size: a.file.size,
          type: a.tipo,
        })),
        requestPath: '/normativa',
      });
      // TODO: Log de desarrollo, elimninar luego de validar en DEV
      console.log('urlsPrefirmadas',urlsPrefirmadas);

      // ── PASO 2a: Subir documento oficial (OBLIGATORIO) ───────────────
      // Si falla → Promise.all lanza → catch general → no se guarda nada, ya que los anexos son opcionales, se dividio la peticion porque si falla un anexo se detiene la ejecucion y todos losa archivos que se subieron antes del problematico quedan huerfanos.
      // Separamos por índice: los primeros N son adjuntos (por lo general es 1 unicamente, pero colocamos n para futuras implementaciones), el resto son anexos.
      const cantidadAdjuntos = params.documentacion_adjunta.length;
      const urlsAdjuntos  = urlsPrefirmadas.slice(0, cantidadAdjuntos);
      const urlsAnexos    = urlsPrefirmadas.slice(cantidadAdjuntos);
      const filesAdjuntos = archivosParaSubir.slice(0, cantidadAdjuntos);
      const filesAnexos   = archivosParaSubir.slice(cantidadAdjuntos);

      await Promise.all(
        urlsAdjuntos.map((urlInfo, i) =>
          uploadFileToPresignedUrl(urlInfo.url, filesAdjuntos[i].file)
        )
      );

      // ── PASO 2b: Subir anexos (OPCIONALES) ───────────────────────────
      // allSettled espera a todos sin importar si alguno falla.
      // El back luego verifica y limpia las key que fallaron.
      await Promise.allSettled(
        urlsAnexos.map((urlInfo, i) =>
          uploadFileToPresignedUrl(urlInfo.url, filesAnexos[i].file)
        )
      );

      // ── PASO 3: Confirmar en el backend con todos los keys ────────────
      const documentacion_adjunta = urlsAdjuntos.map((urlInfo, i) => ({
        key: urlInfo.key,
        nombre: urlInfo.key,
        nombre_real: filesAdjuntos[i].file.name,
        mime_type: filesAdjuntos[i].file.type,
        size: filesAdjuntos[i].file.size,
      }));

      const anexos = urlsAnexos.map((urlInfo, i) => ({
        key: urlInfo.key,
        nombre: urlInfo.key,
        nombre_real: filesAnexos[i].file.name,
        mime_type: filesAnexos[i].file.type,
        size: filesAnexos[i].file.size,
      }));


      delete (newParams as any).documentacion_adjunta;
      delete (newParams as any).anexos;

      const newNormativa = await postNormativaV2({
        ...newParams,
        documentacion_adjunta,
        anexos,
      } as any);


      showSuccessToast("¡La normativa fue creada con éxito!");
      if (onSuccess) onSuccess(newNormativa);
      onClose();
    } catch (err: any) {
      showErrorToast("La normativa no pudo ser creada.");
      console.log(err.message);
    } finally {
      setIsLoading(false);
    }
  };

  const handleSubmitCreate = async (params: initialValues) => {
    try {
      setIsLoading(true);
      const newParams = { ...params };

      if (newParams.fecha_publicacion) {
        newParams.fecha_publicacion = new Date(
          `${newParams.fecha_publicacion}T00:00:00`,
        ).toISOString();
      }

      const docAdjunta = [...params.documentacion_adjunta];
      const anexos = [...params.anexos];
      delete (newParams as any).documentacion_adjunta;
      delete (newParams as any).anexos;

      const newNormativa = await createNormativaBatch({
        formParams: newParams,
        documentacionAdjunta: docAdjunta,
        anexos,
      });

      showSuccessToast("¡La normativa fue creada con éxito!");
      if (onSuccess) onSuccess(newNormativa);
      onClose();
    } catch (err: any) {
      if (err instanceof BatchUploadError) {
        const archivos = err.failedBatches.flatMap((b) => b.fileNames).join(", ");
        showErrorToast(
          `La normativa fue creada pero falló la subida de algunos anexos: ${archivos}`
        );
      } else {
        showErrorToast("La normativa no pudo ser creada.");
      }
      console.log(err.message);
    } finally {
      setIsLoading(false);
    }
  };


  const handleSubmitEditUrlPrefirmada = async (params: initialValues) => {
    try {
      setIsLoading(true);

      const newParams = { ...params };
      if (newParams.fecha_publicacion) {
        newParams.fecha_publicacion = new Date(
          `${newParams.fecha_publicacion}T00:00:00`,
        ).toISOString();
      }

      // Calcular qué documentos existentes se eliminaron
      // isVirtual son los archivos que ya están en el servidor.
      // Comparamos los originales con los que el usuario dejó activos.
      const activesVirtuales = [
        ...params.documentacion_adjunta.filter((f) => f.isVirtual),
        ...params.anexos.filter((f) => f.isVirtual),
      ];

      const originales: DocumentacionAdjuntaI[] = [];
      if (elemento?.documentacionAdjunta) originales.push(elemento.documentacionAdjunta);
      elemento?.anexo?.forEach((a) => originales.push(a));

      const adjuntosAEliminarIds = originales
        .filter((orig) => !activesVirtuales.find((av) => av.fakeId === orig.id))
        .map((orig) => orig.id);

      // Separar archivos nuevos (reales) de los existentes (virtuales)
      // Solo los nuevos pasan por el flujo de la prefirma de s3.
      const nuevosAdjuntos = params.documentacion_adjunta.filter((f) => !f.isVirtual);
      const nuevosAnexos   = params.anexos.filter((f) => !f.isVirtual);

      const archivosParaSubir: { file: FakeFile; tipo: 'documentacion_adjunta' | 'anexo' }[] = [
        ...nuevosAdjuntos.map((f) => ({ file: f, tipo: 'documentacion_adjunta' as const })),
        ...nuevosAnexos.map((f) => ({ file: f, tipo: 'anexo' as const })),
      ];

      let documentacion_adjunta_keys: { key: string; nombre: string; nombre_real: string; mime_type: string; size: number }[] = [];
      let anexos_keys: { key: string; nombre: string; nombre_real: string; mime_type: string; size: number }[] = [];

      if (archivosParaSubir.length > 0) {
        // PASO 1: Obtener URLs prefirmadas (solo para archivos nuevos)
        const urlsPrefirmadas = await getUrlPrefirmada({
          documentos: archivosParaSubir.map((a) => ({
            nombre: a.file.name,
            mimetype: a.file.type,
            size: a.file.size,
            type: a.tipo,
          })),
          requestPath: '/normativa',
        });

        const cantidadAdjuntos = nuevosAdjuntos.length;
        const urlsAdjuntos  = urlsPrefirmadas.slice(0, cantidadAdjuntos);
        const urlsAnexos    = urlsPrefirmadas.slice(cantidadAdjuntos);
        const filesAdjuntos = archivosParaSubir.slice(0, cantidadAdjuntos);
        const filesAnexos   = archivosParaSubir.slice(cantidadAdjuntos);

        // ── PASO 2a: Subir documento oficial nuevo (OBLIGATORIO si hay uno nuevo) ─
        await Promise.all(
          urlsAdjuntos.map((urlInfo, i) =>
            uploadFileToPresignedUrl(urlInfo.url, filesAdjuntos[i].file)
          )
        );

        // ── PASO 2b: Subir nuevos anexos (OPCIONALES) ──────────────────────
        await Promise.allSettled(
          urlsAnexos.map((urlInfo, i) =>
            uploadFileToPresignedUrl(urlInfo.url, filesAnexos[i].file)
          )
        );

        // Construir los arrays de keys a enviar al backend
        documentacion_adjunta_keys = urlsAdjuntos.map((urlInfo, i) => ({
          key: urlInfo.key,
          nombre: urlInfo.key,
          nombre_real: filesAdjuntos[i].file.name,
          mime_type: filesAdjuntos[i].file.type,
          size: filesAdjuntos[i].file.size,
        }));

        anexos_keys = urlsAnexos.map((urlInfo, i) => ({
          key: urlInfo.key,
          nombre: urlInfo.key,
          nombre_real: filesAnexos[i].file.name,
          mime_type: filesAnexos[i].file.type,
          size: filesAnexos[i].file.size,
        }));
      }

      // ── PASO 3: Confirmar en el backend con keys nuevas + ids a eliminar ────
      delete (newParams as any).documentacion_adjunta;
      delete (newParams as any).anexos;

      const newResolucion = await putNormativaV2({
        ...newParams,
        id: elemento!.id,
        documentacion_eliminar: adjuntosAEliminarIds,
        documentacion_adjunta: documentacion_adjunta_keys,
        anexos: anexos_keys,
      } as any);

      showSuccessToast("¡La normativa fue editada con éxito!");
      if (onSuccess) onSuccess(newResolucion);
      onClose();
    } catch (err: any) {
      showErrorToast("La normativa no pudo ser editada.");
      console.log(err.message);
    } finally {
      setIsLoading(false);
    }
  };

  const handleSubmitEdit = async (params: initialValues) => {
    try {
      setIsLoading(true);
      const newParams = { ...params };

      if (newParams.fecha_publicacion) {
        newParams.fecha_publicacion = new Date(
          `${newParams.fecha_publicacion}T00:00:00`,
        ).toISOString();
      }

      // Separar archivos virtuales (existentes) de nuevos
      const activeAdjuntos: FakeFile[] = [];
      const nuevosDocAdjunta: File[] = [];
      const nuevosAnexos: File[] = [];

      params.documentacion_adjunta?.forEach((doc) => {
        if (!doc.isVirtual) nuevosDocAdjunta.push(doc);
        else activeAdjuntos.push(doc);
      });
      params.anexos?.forEach((doc) => {
        if (!doc.isVirtual) nuevosAnexos.push(doc);
        else activeAdjuntos.push(doc);
      });

      // Calcular documentación a eliminar
      const originalAdjuntos: DocumentacionAdjuntaI[] = [];
      if (elemento?.documentacionAdjunta) originalAdjuntos.push(elemento.documentacionAdjunta);
      elemento?.anexo.forEach((anexo) => originalAdjuntos.push(anexo));

      const adjuntosAEliminarIds: EntityID[] = [];
      originalAdjuntos.forEach((oa) => {
        const found = activeAdjuntos.find((aa) => aa.fakeId == oa.id);
        if (!found) adjuntosAEliminarIds.push(oa.id);
      });

      delete (newParams as any).documentacion_adjunta;
      delete (newParams as any).anexos;

      const newResolucion = await editNormativaBatch({
        formParams: newParams,
        normativaId: elemento!.id,
        nuevosDocAdjunta,
        nuevosAnexos,
        documentacionEliminar: adjuntosAEliminarIds,
      });

      showSuccessToast("¡La normativa fue editada con éxito!");
      if (onSuccess) onSuccess(newResolucion);
      onClose();
    } catch (err: any) {
      if (err instanceof BatchUploadError) {
        const archivos = err.failedBatches.flatMap((b) => b.fileNames).join(", ");
        showErrorToast(
          `La normativa fue editada pero falló la subida de algunos anexos: ${archivos}`
        );
      } else {
        showErrorToast("La normativa no pudo ser editada.");
      }
      console.log(err.message);
    } finally {
      setIsLoading(false);
    }
  };


  const handleChangeFile = (e: any) => {
    if (actionType == "edit" && e.target.value.length == 0)
      setWasOriginalFileDeleted(true);

    handleChange(e);
  };

  const {
    values,
    errors,
    touched,
    handleChange,
    handleBlur,
    isSubmitting,
    handleSubmit,
    setValues,
    resetForm,
  } = useFormik({
    initialValues,
    validationSchema: createNormativasSchema,
    onSubmit: actionType === "create" ? handleSubmitCreate : handleSubmitEdit,
  });

  const { loadingAppData, tiposNormativa, alcances, tiposEfecto } = useSelector(
    (st: RootState) => st.appData,
  );

  const handleCreateModal = (modalName: string) => {
    setModalsActionType("create");
    setShowModalABM((st) => ({ ...st, [modalName]: true }));
  };
  const handleCloseModal = (modalName: string) => {
    setShowModalABM((st) => ({ ...st, [modalName]: false }));
    setTimeout(() => setModalsActionType(undefined), 500);
  };

  const addNewElemento = ({
    key,
    elemento,
    isMulti,
  }: {
    key: keyof defaultOptionsSelected;
    elemento: any;
    isMulti?: boolean;
  }) => {
    setDefaultOptionsSelected((st: defaultOptionsSelected) => {
      const getPrevMultiSt = () =>
        st[key] && Array.isArray(st[key]) ? (st[key] as any) : [];
      return {
        ...st,
        [key]: isMulti ? [...getPrevMultiSt(), elemento] : elemento,
      };
    });
  };

  const addNewOrganismo = (elemento: OrganismoI) => {
    addNewElemento({
      key: "default_selected_organismo",
      elemento,
      isMulti: false,
    });
    setValues({ ...values, organismo_id: elemento.id });
  };

  useEffect(() => {
    setIsLoadingFiles(false);
    resetForm();
    if (actionType) {
      renderInitialValues();
    }
  }, [actionType]);

  useEffect(() => {
    if (!alcances) dispatch(fetchAlcances());
    if (!tiposNormativa) dispatch(fetchTiposResoluciones());
    if (!tiposEfecto) dispatch(fetchTiposEfecto());
  }, []);

  const isNacional = values.alcance_id === 1;

  return (
    <>
      <Modal
        show={showModal}
        onHide={onClose}
        size="xl"
        centered
        backdrop="static"
      >
        <Modal.Header>
          <Modal.Title>
            {isEditMode ? "Editar Normativa" : "Nueva Normativa"}
          </Modal.Title>
        </Modal.Header>

        <form onSubmit={handleSubmit}>
          <Modal.Body style={{ position: "relative" }}>
            {isLoadingFiles && (
              <div
                style={{
                  position: "absolute",
                  inset: 0,
                  backgroundColor: "rgba(255, 255, 255, 0.93)",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  zIndex: 10,
                  gap: "12px",
                  borderRadius: "4px",
                }}
              >
                <Loader style={{ margin: "0" }} />
                <span style={{ color: "#555", fontSize: "0.9rem" }}>
                  Cargando...
                </span>
              </div>
            )}
            <Col>
              <Row>
                <Col sm={4} className="mb-2">
                  <Input
                    id={"nombre"}
                    title="Nombre de la normativa"
                    required
                    onChange={handleChange}
                    onBlur={handleBlur}
                    values={values}
                    errors={errors}
                    touched={touched}
                    variant="gray-container"
                    size="lg"
                  />
                </Col>
                <Col sm={4} className="mb-2">
                  <Select
                    id="tipo_normativa_id"
                    title="Tipo"
                    required
                    values={values}
                    errors={errors}
                    touched={touched}
                    onChange={handleChange}
                    optionsFormatConfig={{ value: "id", label: "nombre" }}
                    options={tiposNormativa ?? []}
                    isLoading={loadingAppData.tiposNormativa}
                    placeholder="Tipo"
                    variant="gray-container"
                    size="lg"
                  />
                </Col>
                <Col sm={4} className="mb-2">
                  <Select
                    id="alcance_id"
                    title="Alcance"
                    size="lg"
                    optionsFormatConfig={{ value: "id", label: "nombre" }}
                    options={alcances ?? []}
                    isLoading={loadingAppData.alcances}
                    // disabled={isLoading.gradosNivel}
                    placeholder="Seleccionar"
                    variant="gray-container"
                    required
                    values={values}
                    errors={errors}
                    touched={touched}
                    onChange={handleChange}
                    onBlur={handleBlur}
                  />
                </Col>
                {!isNacional ? (
                  <></>
                ) : (
                  <>
                    <Col sm={6}>
                      <Row className="">
                        <Col sm={12} className="mb-2">
                          <AsyncSelect
                            onChange={handleChange}
                            id="validaciones_nacionales_id"
                            values={values}
                            errors={errors}
                            touched={touched}
                            onBlur={handleBlur}
                            placeholder={"Buscar Validez Nacional"}
                            size="lg"
                            isMulti={true}
                            title="Validez Nacional"
                            getter={getValidezNacionalExpedienteInterno}
                            paramKey={"nombre"}
                            variant="gray-container"
                            arrElementsPath="elementos"
                            optionsFormatConfig={{
                              value: "id",
                              label: (el: ValidezNacionalI) =>
                                `${el.expedienteInterno}`,
                            }}
                            // defaultSelectedOptions={
                            //   defaultOptionsSelected.default_selected_validacion_nacional
                            // }
                            required
                            noOptionsMessage={`No hay opciones disponibles para el nombre ingresado`}
                            emptySelectMessage={`Ingresar un nombre`}
                          />
                        </Col>
                      </Row>
                    </Col>
                    <Col sm={6}>
                      <Row className="">
                        <Col sm={12} className="mb-2">
                          <AsyncSelect
                            onChange={handleChange}
                            id="normativas_id"
                            values={values}
                            errors={errors}
                            touched={touched}
                            onBlur={handleBlur}
                            placeholder={"Buscar Normativa"}
                            size="lg"
                            isMulti={true}
                            title="Normativa Jurisdiccional"
                            getter={() => getNormativas({ alcance_id: 2 })}
                            paramKey={"nombre"}
                            variant="gray-container"
                            arrElementsPath="elementos"
                            optionsFormatConfig={{
                              value: "id",
                              label: (el: NormativaI) => `${el.nombre}`,
                            }}
                            // defaultSelectedOptions={
                            //   defaultOptionsSelected.default_selected_normativa
                            // }
                            required
                            noOptionsMessage={`No hay opciones disponibles para el nombre ingresado`}
                            emptySelectMessage={`Ingresar un nombre`}
                          />
                        </Col>
                      </Row>
                    </Col>
                  </>
                )}

                <Col sm={6} className="mb-2">
                  <Input
                    id={"descripcion"}
                    title="Descripción"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    values={values}
                    errors={errors}
                    touched={touched}
                    variant="gray-container"
                    size="lg"
                  />
                </Col>
                <Col sm={6} className="mb-2">
                  <Select
                    id="tipo_efecto_id"
                    title="Efecto"
                    size="lg"
                    optionsFormatConfig={{ value: "id", label: "nombre" }}
                    options={tiposEfecto ?? []}
                    isLoading={loadingAppData.tiposEfecto}
                    // disabled={isLoading.gradosNivel}
                    placeholder="Seleccionar"
                    variant="gray-container"
                    required
                    values={values}
                    errors={errors}
                    touched={touched}
                    onChange={handleChange}
                    onBlur={handleBlur}
                  />
                </Col>

                <Col sm={6} className="mb-2">
                  <Row className="">
                    <Col sm={10} className="mb-2">
                      <AsyncSelect
                        onChange={handleChange}
                        id="organismo_id"
                        values={values}
                        errors={errors}
                        touched={touched}
                        onBlur={handleBlur}
                        placeholder={"Buscar nombre del organismo"}
                        size="lg"
                        title="Organismo"
                        getter={getAllOrganismos}
                        paramKey={"nombre"}
                        variant="gray-container"
                        arrElementsPath="elementos"
                        optionsFormatConfig={{
                          value: "id",
                          label: (el: OrganismoI) =>
                            `${el.nombre} (${el.abreviatura})`,
                        }}
                        defaultSelectedOptions={
                          defaultOptionsSelected.default_selected_organismo
                        }
                        required
                        noOptionsMessage={`No hay opciones disponibles para el nombre ingresado`}
                        emptySelectMessage={`Ingresar un nombre`}
                      />
                    </Col>
                    <Col sm={1}>
                      <Button
                        onClick={() => handleCreateModal("organismos")}
                        variant="primary"
                        size={"lg"}
                        style={{
                          width: "50px",
                          height: "50px",
                          marginTop: "20px",
                          borderRadius: "50%",
                          fontSize: "1.6rem",
                        }}
                      >
                        {" "}
                        +
                      </Button>
                    </Col>
                  </Row>
                </Col>
                {isNacional ? (
                  <></>
                ) : (
                  <>
                    <Col
                      sm={6}
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <label
                        className="form-check-label"
                        htmlFor="aplicaValidezNacional"
                        style={{ marginRight: "10px" }}
                      >
                        ¿Aplica Validez Nacional?
                      </label>
                      <input
                        id="aplicaValidezNacional"
                        type="checkbox"
                        className="form-check-input"
                        checked={values.aplicaValidezNacional}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        style={{ margin: "0px" }}
                      />
                      {errors.aplicaValidezNacional &&
                        touched.aplicaValidezNacional && (
                          <div className="text-danger">
                            {errors.aplicaValidezNacional}
                          </div>
                        )}
                    </Col>
                  </>
                )}
                <Col sm={6}>
                  <Input
                    id={"fecha_publicacion"}
                    title="Fecha de publicación"
                    required
                    type={"date"}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    values={values}
                    errors={errors}
                    touched={touched}
                    variant="gray-container"
                    size="lg"
                  />
                </Col>
                <Col sm={6}>
                  <InputFile
                    id={"documentacion_adjunta"}
                    title="Cargar documento oficial"
                    required
                    onChange={handleChangeFile}
                    onBlur={handleBlur}
                    values={values}
                    errors={errors}
                    touched={touched}
                  />
                </Col>
                <Col sm={6}>
                  <InputMultiFile
                    id={"anexos"}
                    title="Cargar Anexos"
                    onChange={handleChangeFile}
                    onBlur={handleBlur}
                    values={values}
                    errors={errors}
                    touched={touched}
                  />
                </Col>
              </Row>
            </Col>
          </Modal.Body>
          {!isLoadingFiles && (
            <Modal.Footer>
              <Button
                className="mx-3"
                variant="secondary"
                size="lg"
                onClick={onClose}
              >
                Cancelar
              </Button>
              {!isLoading && (
                <Button
                  variant="primary"
                  size="lg"
                  className="user-submit-button"
                  /* disabled={isSubmitting} */ type="submit"
                >
                  {isEditMode ? "Guardar Cambios" : "Confirmar"}
                </Button>
              )}
              {isLoading && (
                <div className="d-flex justify-content-center w-full">
                  <Spinner />
                </div>
              )}
            </Modal.Footer>
          )}
        </form>
        {isLoading && (
          <div className="d-flex justify-content-center w-full">
            <Spinner />
          </div>
        )}
      </Modal>

      <OrganismosABM
        showModal={showModalABM.organismos}
        actionType={modalsActionType}
        onClose={() => handleCloseModal("organismos")}
        onSuccess={(newEl: OrganismoI) => addNewOrganismo(newEl)}
      />
    </>
  );
};
